'use strict';
import {InfobipApiData, InfobipApiCall} from '../components/infobipApi';

export default class TeaserForm {

    constructor() {

        let form = document.getElementById('teaser-form');
        $('.teaser-form__confirmation').hide();
        // is the element present on the current page
        if (!form) {
            return;
        }

        let input = form.querySelector('input[type="file"]'),
            label = form.querySelector('label'),
            submit = form.querySelector('#submitTeaserForm'),
            errorMsg = form.querySelector('.form-group__file .invalid-feedback')

        // if the form was submitted
        form.addEventListener('submit', e => {
            const eventsubmit = 'form-submit-' + $('.form #language').val() + '-teaser2022';
            const eventsent = 'form-sent-' + $('.form #language').val() + '-teaser2022';
            console.log(eventsubmit);
            console.log(eventsent);

                if (!$('#teaser-form')[0].checkValidity()) {
                    e.preventDefault();

                    $('input, textarea').each(function () {

                        if (!this.checkValidity()) {
                            $(this).parent().addClass('has-errors');

                            // Checkbox
                            $(this).siblings('.invalid-feedback').slideDown();

                            // Other elements
                            $(this).parent().siblings('.invalid-feedback').slideDown();
                        } else {
                            $(this).parent().removeClass('has-errors');
                            $(this).parent().siblings('.invalid-feedback').slideUp();
                            $(this).siblings('.invalid-feedback').slideUp();
                        }
                    });

                } else {
                    e.preventDefault();

                    //Events tracking
                    //ga('send', 'event', eventsubmit, eventsubmit, 'webpage');
                   // plausible(eventsubmit);

                    var ajaxData = new FormData()

                    ajaxData.append('action', 'teaser_form');
                    ajaxData.append('name', $('.form #name').val());
                    ajaxData.append('last', $('.form #last').val());
                    ajaxData.append('email', $('.form #email').val());
                    ajaxData.append('message', $('.form #message').val());
                    ajaxData.append('terms-one-check', $('.form #terms-one-check').val());
                    ajaxData.append('terms-two-check', $('.form #terms-two-check').val());
                    ajaxData.append('id', $('.form #id').val());
                    ajaxData.append('nonce', $('.form #nonce').val());
                    ajaxData.append('pageid', $('.form #pageid').val());

                    //console.log("Form Data: ", ajaxData)


                    $.ajax({
                        url: window.location.origin + '/wp/wp-admin/admin-ajax.php',
                        data: ajaxData,
                        processData: false,
                        contentType: false,
                        type: 'POST',
                        success: function (data) {
                            $('#teaser-form').hide();
                            //document.querySelector('.logo').style.backgroundImage = 'url(/app/themes/argeta-timber/dist/images/svg/logo-argeta-orange.svg)';
                            $('.teaser-form__confirmation').show();
                            $('.teaser-form__email_exist').hide();
                            $('#form-head').hide();
                            $('#form-head-description').hide();
                            $('#form-head-message').hide();

                            //Infobip integration
                           const wrapper = $('#subscribe-form');

                            const target = $("#submitTeaserForm").attr("data-infobip-submit");

                            //Getname
                            const getname = wrapper.find("[data-infobip='"+target+"'] input[name=name]").val();

                            //Get last name
                            const getlastname = wrapper.find("[data-infobip='"+target+"'] input[name=last]").val();

                            //Get email
                            const getemail = wrapper.find("[data-infobip='"+target+"'] input[name=email]").val();

                            //Get message
                            const getmessage = wrapper.find("[data-infobip='"+target+"'] input[name=message]").val();

                            //Get gdpr
                            const getgdprChecked = wrapper.find("[data-infobip='"+target+"'] #terms-two-check");

                            //Get date
                            const date = new Date();
                            var datestring = date.getFullYear() + "-" + (date.getMonth()+1) + "-" + date.getDate();

                            //Get language
                            const getlanguage = wrapper.find("[data-infobip='"+target+"'] input[name=language]").val();

                            //Get country
                            const getcountry = wrapper.find("[data-infobip='"+target+"'] input[name=country]").val();

                            //Send to infobip if GDPR is checked
                            if(getgdprChecked.prop("checked") === true) {
                                const infobipData = new InfobipApiData(
                                    getname ? getname : null,
                                    getlastname ? getlastname : null,
                                    null,
                                    null,
                                    getcountry ? getcountry : "",
                                    null,
                                    null,
                                    null,
                                    getlanguage ? getlanguage : "",
                                    "Exclusive_skrivnostnichef_2022",
                                    "Argeta",
                                    null,
                                    null,
                                    date ? datestring : "",
                                    date ? datestring : "",
                                    null,
                                    getgdprChecked.prop("checked") ? true : false,
                                    null,
                                    null,
                                    null,
                                    true,
                                    false,
                                    false,
                                    false,
                                    true,
                                    getemail ? getemail : null,
                                    null);

                                 console.log("Infobip call: ",infobipData);

                                 InfobipApiCall(infobipData);

                            }

                            //Events tracking
                            ga('send', 'event', eventsent, eventsent, 'webpage');
                            plausible(eventsent);

                            $([document.documentElement, document.body]).animate({
                                scrollTop: $(".teaser-form__confirmation").offset().top - 80
                            }, 500);

                            /*$([document.documentElement, document.body]).animate({
                                scrollTop: 0
                            }, 1000);*/
                        },
                        error: function (error) {
                            console.log(error.responseJSON.data.error);
                            $('.teaser-form__email_exist').slideDown();
                        }
                    });

                }
        });

    }
}
